module.exports = __webpack_public_path__ + "static/media/honor-img6.44b9c986.png";